<template>
    <div class="home">
        <div v-if="[-1, 1, 0, 2, 5, 6, 7, 8].includes(status)">
            <div class="top">
                <div class="top-title">Hcash</div>
                <div class="top-row">
                    <div class="top-row-item"><img class="top-row-item-icon"
                            src="../../assets/home/icon_a1.png"><span>Low threshold</span></div>
                    <div class="top-row-item"><img class="top-row-item-icon"
                            src="../../assets/home/icon_a2.png"><span>Simpler</span></div>
                    <div class="top-row-item"><img class="top-row-item-icon"
                            src="../../assets/home/icon_a3.png"><span>Faster</span></div>
                </div>
            </div>
            <div class="product">
                <div class="product-title">
                    <img class="product-title-icon" src="../../assets/home/icon_amount_p.png">
                    <span>Your available loan amount is</span>
                </div>
                <img class="product-mask" src="../../assets/home/img_money.png">
                <div class="product-number">{{ $thousands(applicationInfo.loanAmount || money[0]) }}</div>
                <!--未申请 -->
                <div v-if="[-1, 1, 0, 8].includes(status)" class="product-btn" @click="toLoan">
                    <span>Apply immediately</span>
                    <svg-icon iconClass="go" class="product-btn-icon" />
                </div>
                <!-- 审核中 -->
                <div v-if="status == 2" class="product-result green_bg green">
                    <div class="product-result-title">Under review</div>
                    <div>Hello, your loan application is under review, please wait patiently.</div>
                </div>
                <!-- 放款中 -->
                <div v-if="status == 6" class="product-result green_bg green">
                    <div class="product-result-title">Loaning</div>
                    <div>Your loan application has been approved and the loan is being issued.</div>
                </div>
                <!-- 放款失败 -->
                <div v-if="status == 7" class="product-result yellow_bg yellow">
                    <div class="product-result-title">Loan failed</div>
                    <div>Your loan has failed, contact customer service as soon as possible. (+
                        {{ customerServicePhone }})
                    </div>
                </div>
                <!-- 已拒绝 -->
                <div v-if="[5].includes(status)" class="product-result yellow_bg yellow">
                    <div class="product-result-title">Rejected</div>
                    <div>Sorry, you have not met our loan requirements, please try again at
                        {{ $dayjs(applicationInfo.refuseExpireTime).format("DD-MM-YYYY") }}</div>
                </div>
                <div v-if="[-1, 1, 0, 8].includes(status)" class="product-tip">
                    <span>Daily interest rate 0,05%</span>
                    <span class="product-tip-split"></span>
                    <span>Quick loan</span>
                </div>
            </div>
            <div class="footer">- Borrowing is easier -</div>
        </div>
        <Passed v-if="[3, 4, 9].includes(status)" :status="status" :applicationInfo="applicationInfo">
        </Passed>
    </div>
</template>

<script>
import Passed from './passed.vue';
import { latest } from '@/api/order';
import { canApply, analyzeLoan } from '@/api/loan'
import { getOrderStatus } from "@/utils/tools.js";

export default {
    components: { Passed },
    data() {
        return {
            status: -1,
            applicationInfo: {},
            product: [],
            money: [],
        }
    },
    computed: {
        customerServicePhone() {
            return this.$store.state.dict.customerServicePhone
        }
    },
    created() {
        this.getLatest()
        this.getProduct()
        sessionStorage.removeItem('operatorId') //清除关联电销
    },
    methods: {
        async getLatest() {
            let res = await latest()
            if (res) {
                this.applicationInfo = res
                this.status = res ? getOrderStatus(res.status) : -1
                if ([3, 4].includes(status) && res.orderInfo && res.orderInfo.overdueDays == 0) {
                    this.status = 9 // 还款日
                }
            } else {
                this.status = -1
            }

        },
        async getProduct() {
            const res = await analyzeLoan()
            this.product = res
            this.handleProduct()
        },
        async handleProduct() {
            this.product.forEach(i => {
                if (!this.money.includes(i.amount)) {
                    this.money.push(i.amount)
                }
                this.money.sort()
            });
        },
        async toLoan() {
            const res = await canApply()
            console.log(res)
            if (res) {
                this.$router.push('/product')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.home {
    height: 100vh;
    overflow-y: scroll;
    background-color: @Main-bg;

    .top {
        height: 229px;
        padding: 36.5px 14px 0;
        box-sizing: border-box;


        &-title {
            color: #1F254D;
            font-weight: bold;
            font-size: 24px;
            font-style: italic;
        }

        &-row {
            margin: 10px 0 10px;
            display: flex;
            font-size: 13px;
            color: #81939B;

            &-item {
                margin: 0 3px 0 0;

                &:last-child {
                    margin: 0;
                }

                &-icon {
                    margin: 0 5.5px 0 0;
                    width: 16px;
                    display: inline-block;
                    vertical-align: text-top;
                }
            }

        }
    }

    .product {
        margin: -112.5px 14px 0 16px;
        padding: 33.5px 0 24.5px;
        font-weight: bold;
        background: linear-gradient(135deg, @MainColor, @SecondaryColor);
        border-radius: 0 20px 20px 20px;

        &-title {
            text-align: center;
            font-size: 14px;
            color: rgba(255, 255, 255, .7);

            &-icon {
                margin: 0 6.5px 0 0;
                width: 20px;
                height: 20px;
                display: inline-block;
                vertical-align: text-bottom;

            }
        }

        &-mask {
            margin: 13.5px 0 0 -6px;
            width: 338px;
            height: 150px;

        }

        &-number {
            margin: -160px 0 0;
            text-align: center;
            font-size: 55px;
            color: #fff;
        }

        &-btn {
            margin: 20px auto 0;
            width: 300px;
            height: 50px;
            line-height: 50px;
            font-size: 19px;
            color: @MainColor;

            text-align: center;

            &-icon {
                margin: 0 0 0 8.5px;
                width: 10px;
                height: 10px;
                vertical-align: middle;
                color: @MainColor;
            }

            border-radius: 27.5px;
            background: linear-gradient(to top, @Main-bg, #FFFFFF);
        }

        &-result {
            margin: 10px 15px 0;
            padding: 26px 19px 30px;
            font-size: 14px;
            text-align: center;
            border-radius: 0 27.5px 27.5px 27.5px;

            &-title {
                margin: 0 0 14px;
                font-size: 27px;
            }


        }

        &-tip {
            margin: 9px 0 0;
            text-align: center;
            font-size: 13px;
            color: rgba(255, 255, 255, .7);

            &-split {
                margin: 0 10px;
                width: 1px;
                height: 11px;
                background-color: rgba(255, 255, 255, .7);
            }
        }

        .green_bg {
            background: linear-gradient(to top, @Main-bg, #FFFFFF);

        }

        .yellow_bg {
            background: linear-gradient(to top, #FEFFCF, #FFFFFF);

        }

        .green {
            color: @MainColor;
        }

        .yellow {
            color: #F3841E
        }
    }

    .process {
        margin: 15.5px 15px 0;
        padding: 24px 15px 30px;
        font-weight: bold;
        background: url('../../assets/home/bg_step.png') no-repeat;
        background-size: 100% 100%;

        &-title {
            margin: 0 0 24px;
            color: #212750;
            font-size: 18px;
        }

        &-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: bold;

            &-item {
                font-size: 16px;
                color: #3F3D5A;
                text-align: center;

                &-icon {
                    margin: 0 auto 10px;
                    width: 49px;
                    height: 49px;
                }
            }
        }
    }

    .feedback {
        margin: 15.5px 15px 0;
        width: 345px;
    }

    .footer {
        margin: 15px 0 0;
        text-align: center;
        color: #B4C3BD;
        font-size: 13px;
    }
}
</style>